const MONTHS_ES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

/**
 * "2026-01-17" o "2026-01-17 10:20" -> "17 enero 26"
 */
export function formatoFecha(input) {
  if (!input) return "";

  // Acepta "YYYY-MM-DD" y también "YYYY-MM-DD HH:mm..."
  const datePart = String(input).trim().slice(0, 10); // "YYYY-MM-DD"
  const [y, m, d] = datePart.split("-");

  if (!y || !m || !d) return "";

  const day = String(parseInt(d, 10)); // "17"
  const monthIndex = parseInt(m, 10) - 1;
  if (monthIndex < 0 || monthIndex > 11) return "";

  const monthName = MONTHS_ES[monthIndex];
  const year2 = y.slice(-2); // "26"

  return `${day} ${monthName} ${year2}`;
}
